import React from 'react'

function Deletdata() {

  return (
    <div>

    </div>
  )
}

export default Deletdata